/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * grimoire/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * Ordinal represents the position within a period (e.g., "first Monday of month").

 - ORDINAL_UNSPECIFIED: Unspecified ordinal.
 - ORDINAL_FIRST: First occurrence (e.g., first Monday).
 - ORDINAL_SECOND: Second occurrence.
 - ORDINAL_THIRD: Third occurrence.
 - ORDINAL_FOURTH: Fourth occurrence.
 - ORDINAL_FIFTH: Fifth occurrence (not all months have a fifth occurrence of each day).
 - ORDINAL_LAST: Last occurrence (e.g., last Friday of month).
 */
export type V1Ordinal = (typeof V1Ordinal)[keyof typeof V1Ordinal];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1Ordinal = {
  ORDINAL_UNSPECIFIED: 'ORDINAL_UNSPECIFIED',
  ORDINAL_FIRST: 'ORDINAL_FIRST',
  ORDINAL_SECOND: 'ORDINAL_SECOND',
  ORDINAL_THIRD: 'ORDINAL_THIRD',
  ORDINAL_FOURTH: 'ORDINAL_FOURTH',
  ORDINAL_FIFTH: 'ORDINAL_FIFTH',
  ORDINAL_LAST: 'ORDINAL_LAST',
} as const;
